import React, { Component } from 'react';

export default class CustomerGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <h2>
          We are in the process of migrating this service to a better solution.
          <br />
          In the meantime, please complete
          <a href="https://docs.google.com/forms/d/e/1FAIpQLSevQuAFfXRgcgql1lbCxCjnD-GUeUDp9AbVAZkSVu0MsQI9MQ/viewform?usp=sf_link">
            this google form
          </a>
          for per diem requests.
          <br />
          <br />
          Apologies for any inconvenience!
        </h2>
      </div>
    );
  }
}
